import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash, faTimes} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import i18next from 'i18next';

class ResetPasswordEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      strengthString: 0,
      confirmPassword: false,
      validRegexIndex: [],
      windowWidth: 0,
      password: '',
      matchPassword: '',
      errorMessage: [],
    };
    this.isGood = this.isGood.bind(this);
    this.isValid = this.isValid.bind(this);
    this.update = this.update.bind(this);
    window.addEventListener('resize', this.update);
  }

  componentDidMount() {
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update);
  }

  update() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  toggleShow() {
    this.setState({hidden: !this.state.hidden});
  }

  isGood(e) {
    const passwordStrength = document.getElementById('password-text');
    let password = document.getElementById('password').value;

    // TextBox left blank.
    if (typeof (password) == 'undefined') {
      password = '';
    }

    // Regular Expressions.
    const regex = [];
    regex.push('[A-Z]'); // Uppercase Alphabet.
    regex.push('[a-z]'); // Lowercase Alphabet.
    regex.push('[0-9]'); // Digit.
    regex.push('[$@$!%*#?&]'); // Special Character.
    regex.push('.{8,}'); // Minimum 8 characters.

    let passed = 0;

    const validRegexIndex = [];

    // Validate for each Regular Expression.
    for (let i = 0; i < regex.length; i++) {
      if (new RegExp(regex[i]).test(password)) {
        passed+=(1/regex.length);
        validRegexIndex.push(i);
      }
    }

    this.setState({validRegexIndex: validRegexIndex});
    const strength = 100 - (Math.floor(passed*100)) + '%';
    passwordStrength.innerHTML = strength;
    this.setState({strengthString: strength});
    this.setState({password: e.target.value});
  }

  isValid(e) {
    const password = document.getElementById('password').value;
    const confermaPassword = document.getElementById('confermaPassword').value;

    if (password === confermaPassword) {
      this.setState({confirmPassword: !this.state.confirmPassword});
    }
    this.setState({matchPassword: e.target.value});
  }

  resetPassword() {
    const data = {password: this.state.password,
      matchPassword: this.state.matchPassword};
    const config = {
      headers: {
        SKIN_ID: 1,
      },
    };
    if ( this.state.password !== '' && this.state.matchPassword !== '') {
      axios.post(`${window.env.REACT_APP_API_URL}/registration-service/password/reset`, data, config)
          .then((res) => {
            this.setState({errorMessage: ''});
            this.props.history.push('/reset-password-success');
          })
          .catch((error) => {
            this.setState({errorMessage: error?.response?.data?.errorMessageList ?? 'Request failed'});
          });
    }
  }

  render() {
    const {strengthString, confirmPassword, validRegexIndex, windowWidth, errorMessage, hidden} = this.state;
    const style = {width: strengthString};
    return (
      <React.Fragment>
        {windowWidth > 767 ?
            <div className={'reset-password-desktop'}>
              <div>
                <div className={'header-popup flex space-between '}>
                  <p id={'test1'} className={'p0 m-0 accent-color'}>{i18next.t('Imposta nuova password')}</p>
                  <div>
                    <FontAwesomeIcon icon={faTimes}
                      className={'light-grey pointer'}
                      onClick={() => this.props.history.push('/')}
                    />
                  </div>
                </div>
                <form className={'body-popup nuova-password'}>
                  <div className={'relative tooltip'}>
                    <div className="white hide" id="password-text"> </div>
                    <input autoComplete={'none'}
                      id='password'
                      name='password'
                      className={'input-password'}
                      type={this.state.hidden ? 'password' : 'text'}
                      placeholder={i18next.t('Nuova password')}
                      onChange={(e) => this.isGood(e)}
                    />
                    {hidden ?
                      <FontAwesomeIcon icon={faEyeSlash}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>:
                      <FontAwesomeIcon icon={faEye}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>
                    }
                    <div className={'decorative-pass-verification ' +
                            (strengthString === 0 ? 'w0' : '')}
                    > </div>
                    <div className={'progress-bar-password'}
                      style={style}>
                    </div>
                    <div className={'absolute z-index-1 tooltiptext'}>
                      <p className={'p0 m-0 '+
                                (validRegexIndex.indexOf(0)>-1 ? 'green' : '')}>
                                    {i18next.t('• Uppercase Alphabet')}
                      </p>
                      <p className={'p0 m-0 ' +
                                (validRegexIndex.indexOf(1)>-1 ? 'green' : '')}>
                                    {i18next.t('• Lowercase Alphabet')}
                      </p>
                      <p className={'p0 m-0 ' +
                                (validRegexIndex.indexOf(2)>-1 ? 'green' : '')}>
                                    {i18next.t('• Numbers')}
                      </p>
                      <p className={'p0 m-0 ' +
                                (validRegexIndex.indexOf(3)>-1 ? 'green' : '')}>
                                    {i18next.t('• Special Character')}
                      </p>
                      <p className={'p0 m-0 ' +
                                (validRegexIndex.indexOf(4)>-1 ? 'green' : '')}>
                                    {i18next.t('• Minimum 8 characters')}
                      </p>
                    </div>
                  </div>
                  <div className={'relative'}>
                    <input autoComplete={'none'}
                      id='confermaPassword'
                      name='confermaPassword'
                      className={'input-password '}
                      type={this.state.hidden ? 'password' : 'text'}
                      placeholder={i18next.t('Conferma password')}
                      onChange={(e) => this.isValid(e)}
                    />
                    {hidden ?
                      <FontAwesomeIcon icon={faEyeSlash}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>:
                      <FontAwesomeIcon icon={faEye}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>
                    }
                    {errorMessage.length > 0 &&
                    <div className={'password-error'}>
                      {errorMessage.map((error, index) => {
                        return (
                          <div key={index}>
                            {error.fieldName === 'matchPassword' &&
                            <p className={'m-0 pink'}>{error.messageError}</p>
                            }
                          </div>
                        );
                      })
                      }
                    </div>
                    }
                  </div>
                  {errorMessage.length > 0 &&
                  <div className={'password-error'}>
                    {errorMessage.map((error, index) => {
                      return (
                        <div key={index}>
                          {error.fieldName === 'password' &&
                          <p className={'m-0 pink'}>{error.messageError}</p>
                          }
                        </div>
                      );
                    })
                    }
                  </div>
                  }
                  <div className={'button-wrapper'}>
                    <div className={'button'}
                      onClick={() => this.resetPassword()}
                    >{i18next.t('SALVA')}</div>
                  </div>
                </form>
              </div>
            </div> :
            <div className={'reset-password-mobile'}>
              <div className={'reset-password'}>
                <div className={'header-popup flex space-between '}>
                  <p id={'test1'} className={'p0 m-0 light-grey p20'}>{i18next.t('Imposta nuova password')}</p>
                  <div>
                    <FontAwesomeIcon icon={faTimes}
                      className={'light-grey pointer'}
                      onClick={() => this.props.history.push('/')}
                    />
                  </div>
                </div>
                <form className={'body-popup nuova-password'}>
                  <div className={'relative'}>
                    <div className="white hide" id="password-text"> </div>
                    <input autoComplete={'none'}
                      id='password'
                      name='password'
                      className={'input-password'}
                      type={this.state.hidden ? 'password' : 'text'}
                      placeholder={i18next.t('Nuova password')}
                      onChange={(e) => this.isGood(e)}
                    />
                    {hidden ?
                      <FontAwesomeIcon icon={faEyeSlash}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>:
                      <FontAwesomeIcon icon={faEye}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>
                    }
                    <div className={'decorative-pass-verification ' +
                            (strengthString === 0 ? 'w0' : '')}
                    > </div>
                    <div className={'progress-bar-password'}
                      style={style}>
                    </div>
                  </div>
                  <div className={'relative'}>
                    <input autoComplete={'none'}
                      id='confermaPassword'
                      name='confermaPassword'
                      className={'input-password '}
                      type={this.state.hidden ? 'password' : 'text'}
                      placeholder={i18next.t('Conferma password')}
                      onChange={(e) => this.isValid(e)}
                    />
                    {hidden ?
                      <FontAwesomeIcon icon={faEyeSlash}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>:
                      <FontAwesomeIcon icon={faEye}
                        className={'icon-eye pointer'}
                        onClick={() => this.toggleShow()}/>
                    }
                    <div className={'decorative-pass-verification ' +
                            (confirmPassword === false ? 'hide' : '')}
                    style={{width: '100%'}}
                    > </div>
                  </div>
                  <div className={'button-wrapper'}>
                    <div className={'button'}
                      onClick={() => this.resetPassword()}
                    >
                      {i18next.t('SALVA')}
                    </div>
                  </div>
                </form>
                <div className={'footer-popup '}>
                  <p id={'test2'} className={'p0'}>{i18next.t('Non hai ricevuto l\'email? Contatta')}{' '}<span>{i18next.t('l\'assistenza')}</span></p>
                </div>
              </div>

            </div>
        }
      </React.Fragment>
    );
  }
}

export default ResetPasswordEmail;
